import Cookies from "js-cookie";

const TOKEN_COOKIE_KEY = "token";

export const getToken = () => {
  return Cookies.get(TOKEN_COOKIE_KEY);
};

export const setToken = (token: string) => {
  Cookies.set(TOKEN_COOKIE_KEY, token, {
    expires: 1, // 1 day
    path: "/",
    sameSite: "lax",
    secure: true,
  });
};

export const deleteToken = () => {
  Cookies.remove(TOKEN_COOKIE_KEY, { path: "/" });
};
